import { Row } from '@unistocks/components/layout/flex';
import { Page } from '@unistocks/components/page/page';
import { ThemeSwitch } from '@unistocks/components/settings/theme-switch';
import { AuthHeader } from '@unistocks/features/authentication/header/header';
import { useIsKeyboardShown } from '@unistocks/shared/hooks/use-is-keyboard-shown';
import { t } from '@unistocks/shared/localization/index.ts';
import { Stack } from 'expo-router';

import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { AnimatePresence, isWeb, useMedia } from 'tamagui';

export default function AuthLayout() {
  const { bottom } = useSafeAreaInsets();
  const isKeyboardShown = useIsKeyboardShown();
  const media = useMedia();

  return (
    <>
      {isWeb ? <AuthHeader /> : null}
      <Page
        sidebar={false}
        size="small"
        pt={isWeb && media.sm ? '$5' : undefined}
        pb={isKeyboardShown ? undefined : bottom}
        px={'$3'}
      >
        {isWeb ? null : <AuthHeader />}
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: 'transparent' }
          }}
        >
          <Stack.Screen name="index" redirect />
          <Stack.Screen
            name="login"
            options={{ animation: 'slide_from_left', title: t('AbpUi::Login') }}
          />
          <Stack.Screen
            name="register"
            options={{ animation: 'slide_from_right', title: t('AbpUi::Register') }}
          />
          <Stack.Screen
            name="forgot-password"
            options={{ animation: 'slide_from_right', title: t('AbpAccount::PasswordReset') }}
          />
          <Stack.Screen name="reset-password" options={{ title: t('AbpAccount::PasswordReset') }} />
          <Stack.Screen name="email-confirmation" options={{ title: t('::EmailConfirmation') }} />
        </Stack>

        <AnimatePresence>
          {media.sm || isKeyboardShown ? null : (
            <Row
              mt={'$1'}
              mb={'$3'}
              justifyContent={'center'}
              transition={'quicker'}
              exitStyle={{ y: 200 }}
              enterStyle={{ y: 200 }}
              bottom={0}
            >
              <ThemeSwitch size={'$2'} />
            </Row>
          )}
        </AnimatePresence>
      </Page>
    </>
  );
}
